import { render } from "./OrdersList.vue?vue&type=template&id=7b5c3dfc&scoped=true"
import script from "./OrdersList.vue?vue&type=script&lang=js"
export * from "./OrdersList.vue?vue&type=script&lang=js"

import "./OrdersList.vue?vue&type=style&index=0&id=7b5c3dfc&lang=less&scoped=true"
import "./OrdersList.vue?vue&type=style&index=1&id=7b5c3dfc&scoped=true&lang=css"
import "./OrdersList.vue?vue&type=style&index=2&id=7b5c3dfc&lang=css"
import "./OrdersList.vue?vue&type=style&index=3&id=7b5c3dfc&lang=css"
import "./OrdersList.vue?vue&type=style&index=4&id=7b5c3dfc&lang=css"
import "./OrdersList.vue?vue&type=style&index=5&id=7b5c3dfc&lang=css"
import "./OrdersList.vue?vue&type=style&index=6&id=7b5c3dfc&lang=css"
import "./OrdersList.vue?vue&type=style&index=7&id=7b5c3dfc&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b5c3dfc"]])

export default __exports__